<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="30.573" height="27.614" viewBox="326.714 295.5 30.573 27.614">
        <g data-name="9658798311642235000">
            <path
                d="M356.793 295.5h-29.586a.493.493 0 0 0-.493.493v26.628c0 .272.22.493.493.493h29.586c.273 0 .493-.22.493-.493v-26.628a.493.493 0 0 0-.493-.493Zm-.493.986v4.93h-28.6v-4.93h28.6Zm-28.6 6.903v-.986h3.945v.986H327.7Zm4.93-.986h3.946v.986h-3.945v-.986Zm4.932 0h3.945v.986h-3.945v-.986Zm4.931 0h3.945a.987.987 0 0 1-.986.986h-2.959v-.986ZM327.7 322.128v-17.752h17.752a1.974 1.974 0 0 0 1.972-1.973h8.876v19.725h-28.6Z"
                fill="#ec4b1d"
                fill-rule="evenodd"
                data-name="Path 361"
            />
            <path
                d="M330.165 300.43c.816 0 1.48-.663 1.48-1.479 0-.815-.664-1.479-1.48-1.479-.815 0-1.479.664-1.479 1.48 0 .815.664 1.479 1.48 1.479Zm0-1.972a.494.494 0 1 1-.001.988.494.494 0 0 1 .001-.988Z"
                fill="#ec4b1d"
                fill-rule="evenodd"
                data-name="Path 362"
            />
            <path
                d="M334.11 300.43c.816 0 1.48-.663 1.48-1.479 0-.815-.664-1.479-1.48-1.479-.815 0-1.48.664-1.48 1.48 0 .815.665 1.479 1.48 1.479Zm0-1.972a.494.494 0 1 1-.001.988.494.494 0 0 1 .001-.988Z"
                fill="#ec4b1d"
                fill-rule="evenodd"
                data-name="Path 363"
            />
            <path
                d="M353.835 300.43c.815 0 1.479-.663 1.479-1.479 0-.815-.664-1.479-1.48-1.479-.815 0-1.479.664-1.479 1.48 0 .815.664 1.479 1.48 1.479Zm0-1.972a.494.494 0 1 1-.002.988.494.494 0 0 1 .002-.988Z"
                fill="#ec4b1d"
                fill-rule="evenodd"
                data-name="Path 364"
            />
            <path
                d="M338.055 300.43h11.835c.815 0 1.48-.663 1.48-1.479 0-.815-.665-1.479-1.48-1.479h-11.835c-.816 0-1.48.664-1.48 1.48 0 .815.664 1.479 1.48 1.479Zm0-1.972h11.835a.494.494 0 0 1 0 .986h-11.835a.494.494 0 0 1 0-.986Z"
                fill="#ec4b1d"
                fill-rule="evenodd"
                data-name="Path 365"
            />
            <path
                d="M342 311.772a.494.494 0 0 1-.493-.493h-.986c0 .642.413 1.185.986 1.389v.584h.986v-.584c.573-.204.986-.747.986-1.389 0-.816-.663-1.48-1.479-1.48a.494.494 0 1 1 .493-.492h.986c0-.642-.413-1.185-.986-1.389v-.584h-.986v.584a1.477 1.477 0 0 0-.986 1.389c0 .815.663 1.479 1.479 1.479a.494.494 0 0 1 0 .986Z"
                fill="#ec4b1d"
                fill-rule="evenodd"
                data-name="Path 366"
            />
            <path d="M340 314.307h4v1h-4v-1z" fill="#ec4b1d" fill-rule="evenodd" data-name="Rectangle 1" />
            <path d="M340 316.307h4v1h-4v-1z" fill="#ec4b1d" fill-rule="evenodd" data-name="Rectangle 2" />
            <path d="M340 318.307h2v1h-2v-1z" fill="#ec4b1d" fill-rule="evenodd" data-name="Rectangle 3" />
            <path d="M343 318.307h1v1h-1v-1z" fill="#ec4b1d" fill-rule="evenodd" data-name="Rectangle 4" />
            <path
                d="M353.835 306.348h-7.397v-.493a.493.493 0 0 0-.493-.493h-7.89a.493.493 0 0 0-.493.493v.493h-7.397a.493.493 0 0 0-.493.493v12.821c0 .273.221.493.493.493h7.397v.493c0 .273.22.493.493.493h7.89c.272 0 .493-.22.493-.493v-.493h7.397c.272 0 .493-.22.493-.493v-12.82a.493.493 0 0 0-.493-.494Zm-23.177 12.82v-11.834h6.904v11.835h-6.904Zm14.794.987h-6.904v-13.807h6.904v13.807Zm7.89-.986h-6.904v-11.835h6.904v11.835Z"
                fill="#ec4b1d"
                fill-rule="evenodd"
                data-name="Path 367"
            />
            <path
                d="M349.89 312.758a.494.494 0 0 1-.493-.493h-.987c0 .642.414 1.185.987 1.389v.584h.986v-.584c.572-.204.986-.747.986-1.389 0-.815-.664-1.479-1.48-1.479a.494.494 0 1 1 .494-.493h.986c0-.642-.414-1.185-.986-1.389v-.584h-.986v.584a1.477 1.477 0 0 0-.987 1.389c0 .815.664 1.48 1.48 1.48a.494.494 0 0 1 0 .985Z"
                fill="#ec4b1d"
                fill-rule="evenodd"
                data-name="Path 368"
            />
            <path d="M347 315.307h5v1h-5v-1z" fill="#ec4b1d" fill-rule="evenodd" data-name="Rectangle 5" />
            <path d="M347 317.307h3v1h-3v-1z" fill="#ec4b1d" fill-rule="evenodd" data-name="Rectangle 6" />
            <path d="M351 317.307h1v1h-1v-1z" fill="#ec4b1d" fill-rule="evenodd" data-name="Rectangle 7" />
            <path
                d="M334.11 312.758a.494.494 0 0 1-.493-.493h-.986c0 .642.414 1.185.986 1.389v.584h.986v-.584c.573-.204.987-.747.987-1.389 0-.815-.664-1.479-1.48-1.479a.494.494 0 1 1 .493-.493h.987c0-.642-.414-1.185-.987-1.389v-.584h-.986v.584a1.477 1.477 0 0 0-.986 1.389c0 .815.664 1.48 1.48 1.48a.494.494 0 0 1 0 .985Z"
                fill="#ec4b1d"
                fill-rule="evenodd"
                data-name="Path 369"
            />
            <path d="M332 315.307h5v1h-5v-1z" fill="#ec4b1d" fill-rule="evenodd" data-name="Rectangle 8" />
            <path d="M332 317.307h3v1h-3v-1z" fill="#ec4b1d" fill-rule="evenodd" data-name="Rectangle 9" />
            <path d="M336 317.307h1v1h-1v-1z" fill="#ec4b1d" fill-rule="evenodd" data-name="Rectangle 10" />
        </g>
    </svg>
</template>

<script>
export default {
    name: "SelectPlan",
};
</script>
